import React, { DOMAttributes } from 'react';
import { IconsSizes } from 'enums';
import * as S from './IconPadded.styles';

type Props = {
  src: string;
  alt?: string;
  className?: string;
  customStyles?: Partial<
    Record<
      'desktop' | 'mobile',
      {
        padding?: string;
        size?: IconsSizes;
      }
    >
  >;
} & DOMAttributes<HTMLDivElement>;

export const IconPadded = ({
  src,
  alt,
  className,
  customStyles,
  ...attrs
}: Props) => {
  return (
    <S.Wrapper
      className={className}
      paddingMobile={customStyles?.mobile?.padding}
      paddingDesktop={customStyles?.desktop?.padding}
      sizeMobile={customStyles?.mobile?.size}
      sizeDesktop={customStyles?.desktop?.size}
      {...attrs}
    >
      <S.Icon src={src} alt={alt} />
    </S.Wrapper>
  );
};
